import SessaoUsuarioService from "@/services/SessaoUsuarioService";

export const sessaoUsuario = {
  namespaced: true,
  state: {
    sessaoUsuario: {},
  },
  actions: {
    getSessaoUsuarioOData({ commit }, payload) {
      return SessaoUsuarioService.GetSessaoUsuarioOData(payload).then(
        (sessaoUsuario) => {
          return Promise.resolve(sessaoUsuario);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default sessaoUsuario;
